export default "__VITE_ASSET__TGGir$y6__"